import { Component } from '@angular/core';

@Component({
  selector: 'things-group-page',
  templateUrl: './thingsGroup.component.html'
})
export class ThingsGroupPageComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/pages/things/thingsGroup.component.ts